import { ChangeDetectionStrategy, Component, computed, inject, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { RankingType } from 'src/app/gamification/services/models/ranking.model';
import { Detail } from 'src/app/gamification/services/models/score-detail.model';
import { GamificationFacade } from 'src/app/gamification/state/gamification.facade';

@Component({
  selector: 'app-score',
  templateUrl: './score.component.html',
  styleUrls: ['./score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScoreComponent implements OnInit, OnDestroy {
  private readonly gamificationFacade = inject(GamificationFacade);

  @Input() rankingType: RankingType;

  private scoreSubscription: Subscription;

  readonly isLoading = signal(true);
  readonly scoreDetail = signal<Detail[] | undefined>(undefined);
  readonly totalScore = computed(() => this.scoreDetail().reduce((acc, item) => acc + item.subtotal, 0) ?? 0);

  ngOnInit() {
    if (this.rankingType === RankingType.MONTHLY) {
      this.gamificationFacade.getMonthlyScore();
      this.scoreSubscription = this.gamificationFacade.monthlyScore$.subscribe((score) => {
        if (score.actions.length > 0) {
          this.scoreDetail.set(score.actions);
          this.isLoading.set(false);
        }
      });
    } else {
      this.gamificationFacade.getGeneralScore();
      this.scoreSubscription = this.gamificationFacade.generalScore$.subscribe((score) => {
        if (score.actions.length > 0) {
          this.scoreDetail.set(score.actions);
          this.isLoading.set(false);
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.scoreSubscription.unsubscribe();
  }

}
